import React from 'react';
import Checkbox from 'material-ui/Checkbox';

import styles from '../../../styles.js';
import ComingSoon from './ComingSoon';
import './filterSideBar.css';

const ParkingCheckBox = ({
  handleParkinglotFilter = () => {},
  parkinglots = []
}) => (
  <div className="filter-container">
    <h4 className="filter-title">Location</h4>
    <div className="filter-content">
      <div className="parking-filters">
        {parkinglots.map(parkinglot => (
          <Checkbox
            defaultChecked
            key={parkinglot.street_address}
            iconStyle={styles.CheckboxFilterMui}
            label={parkinglot.city}
            labelPosition="left"
            labelStyle={styles.LabelFilterMui}
            onCheck={(e, isChecked) => {
              handleParkinglotFilter(parkinglot, isChecked);
            }}
          />
        ))}
        {parkinglots.length === 1 ? (
          <ComingSoon cities={['Mississauga', 'Scarborough']} />
        ) : null}
      </div>
    </div>
  </div>
);

export default ParkingCheckBox;



// WEBPACK FOOTER //
// ./src/components/Book/FilterSidebar/ParkingCheckBox.js